import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { BotHead } from './..'
import { ExclamationTriangle } from '../Svg'

import styles from './ListingStatusHead.module.scss'

const ListingStatusHead = ({ color, spin, fail, className }) => (
  <div
    className={classnames(
      styles.wrapper,
      styles[`color-${!fail && color}`],
      spin && styles.loading,
      fail && styles.errored,
      className
    )}
  >
    {fail ? <ExclamationTriangle /> : <BotHead color={color} />}
  </div>
)

ListingStatusHead.propTypes = {
  color: PropTypes.string,
  spin: PropTypes.bool,
  fail: PropTypes.any,
  className: PropTypes.string,
}

export default ListingStatusHead
